
import React from 'react';
import { useZxing } from 'react-zxing';

export function ZXingScanner({ onScan, onClose }) {
  const { ref } = useZxing({
    onDecodeResult: (result) => { if (result) onScan(result); },
    timeBetweenDecodingAttempts: 220,
    constraints: { video: { facingMode: 'environment' } },
  });
  
  return (
    <div className="relative w-[280px] h-[280px] border rounded-lg overflow-hidden">
      <video ref={ref} className="w-full h-full object-cover" data-testid="qr-video" />
      <div className="qr-overlay" />
      <button className="absolute top-2 right-2 text-xs underline" data-testid="close-scanner" onClick={onClose}>Close</button>
    </div>
  );
}
